import React from "react";
import Typography from "@material-ui/core/Typography";
import { InfoOutlined } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  banner: {
    display: "flex",
    alignItems: "flex-start",
    margin: "0 0 16px",
    padding: "12px 16px",
    background: "#fff8e1",
    borderLeft: "4px solid #ffb300",
    borderRadius: 4
  },
  icon: { color: "#f57c00", marginRight: 12, marginTop: 2 },
  title: { fontWeight: 600, marginBottom: 2 }
});

export default function InfoBanner({ title, children }: { title: string; children: any }) {
  const classes = useStyles();
  return (
    <div className={classes.banner}>
      <InfoOutlined className={classes.icon} />
      <div>
        <Typography variant="body2" className={classes.title}>{title}</Typography>
        <Typography variant="body2" color="textSecondary">{children}</Typography>
      </div>
    </div>
  );
}
